export default {
  drawer: null,
  color: 'primary',
  image: 'https://lh3.googleusercontent.com/p/AF1QipPq3TLvYsv7AxS1vxGk_m-jDGoBaqiC1FtFmWtc=w1024-k',
  // sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)'
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.34)'
}
